import { render, staticRenderFns } from "./CooperationAgreementModal.vue?vue&type=template&id=715d48fa&scoped=true&"
import script from "./CooperationAgreementModal.vue?vue&type=script&lang=js&"
export * from "./CooperationAgreementModal.vue?vue&type=script&lang=js&"
import style0 from "./CooperationAgreementModal.vue?vue&type=style&index=0&id=715d48fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "715d48fa",
  null
  
)

export default component.exports